import type { ReactNode } from 'react';
import {
  validationArrow,
  validationClass,
  type IntervalFields,
} from '@/lib/lab/labDisplay';
import { cn } from '@/utils/cn';

/** Shared result mark: same arrow and colour in biochemistry and LMV quantitative findings. */
export function LabValidatedValue({
  validation,
  interval,
  corrected,
  children,
}: {
  validation: string | null | undefined;
  interval: IntervalFields;
  corrected?: boolean;
  children: ReactNode;
}) {
  const flag = validationClass(validation);
  const arrow = validationArrow(validation, interval);
  return (
    <span
      className={cn(
        flag === 'low' && 'lab-value--low',
        flag === 'high' && 'lab-value--high',
        flag === 'abnormal' && 'lab-value--abnormal',
        corrected && 'lab-value--corrected',
      )}
    >
      {arrow ? <span className="lab-arrow">{arrow}</span> : null}
      {children}
    </span>
  );
}
